import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Mark, Xp } from '../../../../Component/Layouts/Web/Student/WebUi';
import { useWeb } from '../../../../Component/Layouts/Web/Student/WebContext';
import { WEB_BASE } from '../../../../Component/Layouts/Web/Student/WebLayout';
import { badges } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Achievements = () => {
  const navigate = useNavigate();
  const { xp, showToast } = useWeb();

  return (
    <>
      <div className="web-h">
        <div>
          <h1>Achievements & badges</h1>
          <p>{xp.toLocaleString()} XP · 14 of 50 badges collected</p>
        </div>
        <button type="button" className="web-btn" onClick={() => showToast('Choose a photo or certificate')}>+ Upload</button>
      </div>
      <div className="web-badges">
        {badges.map((badge) => (
          <button
            type="button"
            key={badge.title}
            className={badge.locked ? 'lock' : ''}
            onClick={() => showToast(`${badge.title}${badge.locked ? ' is locked' : ' unlocked'}`)}
          >
            <Mark name={badge.icon} from={badge.from} to={badge.to} />
            <div style={{ marginTop: 8 }}>{badge.title}</div>
          </button>
        ))}
      </div>
      <button type="button" className="web-card web-row" style={{ marginTop: 16, width: '100%', textAlign: 'left', cursor: 'pointer' }} onClick={() => navigate(`${WEB_BASE}/achievement`)}>
        <Mark name="trophy" from="#fbbf24" to="#f97316" />
        <div className="web-grow">
          <b>Won 2nd Prize – Inter-College Hackathon</b>
          <div className="web-mut">3 photos · Certificate</div>
          <Xp amount={150} />
        </div>
        <Icon name="next" />
      </button>
    </>
  );
};

export default Achievements;
